function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M54.75 0L27.374 40h6.843L61.26 0h-6.51zM69.683 24.738V2.888H65.09l-24.23 34.73h7.47l14.693-21.14v21.14h5.467l14.6-21.269v21.268h6.703V2.887H84.95L69.683 24.738z",
  fill: "#C4C6D4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.355 31.185h1.656l-4.192 6.442H15.672L6.4 26.325v11.302H0V2.937l11.37.03c2.979 0 5.837 1.21 7.944 3.367a11.642 11.642 0 013.294 8.131c0 2.485-.769 4.905-2.195 6.914a11.512 11.512 0 01-5.745 4.274l9.176 11.183v-33.9H39.85v6.215h-9.495v7.588h9.934v2.472l-2.54 3.5h-7.394v8.474zM6.399 19.211l4.748-.054a4.86 4.86 0 003.476-1.474 5.094 5.094 0 001.44-3.559 5.093 5.093 0 00-1.44-3.558 4.86 4.86 0 00-3.476-1.474H6.399v10.12z",
  fill: "#C4C6D4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.145 37.612v-3.955l-2.98 3.955h2.98z",
  fill: "#C4C6D4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.393 2.887H133l-12.147 17.427 11.741 17.303h-7.611l-7.979-11.756-2.028 2.907 6.032 8.85-7.882.034-2.183-3.095-2.125 3.06h-7.612l5.902-8.508-.715-.989h-7.969v9.497h-6.452V2.887h5.356l13.885 20.349 2.024-2.907-11.813-17.392h7.616l8.056 11.865 8.297-11.915zm-26.96 12.686V22h4.488l-4.487-6.427z",
  fill: "#C4C6D4"
});

function SvgRemaxinline(props) {
  return React.createElement("svg", _extends({
    width: 133,
    height: 40,
    viewBox: "0 0 133 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgRemaxinline;